// @flow
import cn from 'classnames';
import React from 'react';

import type { FiveSymbolLocale } from '#common/types/locale';

import { getPrivacySettingsText, getUSAPrivacySettingsText } from '../../../utils/translation';


import './style.pcss';

type Props = {
  className: string,
  locale: FiveSymbolLocale
}

const PrivacySettingsButton = ({
  className,
  locale
}: Props) => (
  <div
    className={cn('ui-site-privacy-settings-button', className)}
    data-privacy-settings-button
  >
    <div
      className='ui-site-privacy-settings-button__text'
      data-privacy-settings-button-text
    >
      {getPrivacySettingsText(locale)}
    </div>
    <div
      className='ui-site-privacy-settings-button__text'
      data-privacy-settings-button-usa-text
      hidden
    >
      {getUSAPrivacySettingsText(locale)}
    </div>
    <div className='ui-site-privacy-settings-button__icon' />
  </div>
);

export default PrivacySettingsButton;
